import type { ListData } from '../../../types';
import useToast from '../contexts/useToast';

type Props = {
  item: ListData;
};

const ResetButton = ({ item }: Props) => {
  const { showToast } = useToast();

  const handleResetContent = async () => {
    const confirmed = window.confirm(
      'Are you sure you want to reset this content? This will re-scrape the URL, delete audio files, and regenerate audio. User progress will be preserved.'
    );
    if (!confirmed) return;

    try {
      const res = await fetch('/api/content/reset', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contentId: item.id }),
      });
      if (!res.ok) {
        const data = await res.json();
        showToast(data.error || 'Failed to reset content.', 'error');
        return;
      }
      const data = await res.json();
      showToast(
        `Content reset. Previous audio: ${Math.round(data.previousSecondsGenerated)}s`,
        'success'
      );
      // Reload to see updated content
      window.location.reload();
    } catch (err) {
      console.error('Failed to reset content', err);
      showToast('Failed to reset content.', 'error');
    }
  };

  return (
    <button
      className="pill-button"
      onClick={handleResetContent}
      title="Reset content (re-scrape and regenerate)"
    >
      Reset
    </button>
  );
};

export default ResetButton;
